"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Config = /** @class */ (function () {
    function Config(options) {
        this.dev = (options === null || options === void 0 ? void 0 : options.dev) || false;
        this.url = (options === null || options === void 0 ? void 0 : options.url) || '';
        if (typeof (options === null || options === void 0 ? void 0 : options.delay) !== 'number') {
            this.delay = 1000;
        }
        else {
            this.delay = Math.max(options === null || options === void 0 ? void 0 : options.delay, 1000);
        }
    }
    Config.prototype.setDelay = function (delay) {
        this.delay = delay;
    };
    return Config;
}());
exports.default = Config;
//# sourceMappingURL=config.js.map